import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import {
  SOCIAL_ECOMM_CREATE_ACCOUNT,
  GTB_CHECKOUT,
  PUBLIC_SHOP_CHECKOUT,
  TESTING_CHECKOUT_V2,
} from './AppRoutesConstants';
import GTBCustomizePage from './pages/GTBCustomize';
import SocialEcommRegistrationPage from './pages/SocialEcommRegistration';
import PublicShop from './pages/PublicShop';
import CheckoutTest from './pages/CheckoutTest';

const AppRoutes = () => (
  <Router>
    <Switch>
      <Route
        exact
        path={SOCIAL_ECOMM_CREATE_ACCOUNT}
        component={SocialEcommRegistrationPage}
      />
      <Route exact path={GTB_CHECKOUT} component={GTBCustomizePage} />
      <Route exact path={PUBLIC_SHOP_CHECKOUT} component={PublicShop} />
      <Route exact path={TESTING_CHECKOUT_V2} component={CheckoutTest} />
    </Switch>
  </Router>
);

export default AppRoutes;
